import { render, staticRenderFns } from "./DealersUserDetail.vue?vue&type=template&id=2fa7579e&scoped=true"
import script from "./DealersUserDetail.vue?vue&type=script&lang=ts"
export * from "./DealersUserDetail.vue?vue&type=script&lang=ts"
import style0 from "./DealersUserDetail.vue?vue&type=style&index=0&id=2fa7579e&lang=scss"
import style1 from "./DealersUserDetail.vue?vue&type=style&index=1&id=2fa7579e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa7579e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fa7579e')) {
      api.createRecord('2fa7579e', component.options)
    } else {
      api.reload('2fa7579e', component.options)
    }
    module.hot.accept("./DealersUserDetail.vue?vue&type=template&id=2fa7579e&scoped=true", function () {
      api.rerender('2fa7579e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dealers-users/components/DealersUserDetail.vue"
export default component.exports